/**
 * Code from Vue 2 mixin now in a Vue 3 composable.
 *
 * @author cm359n
 */

import * as lst from '@/components/localStorage.js'

export const useUserMethods = () => {
  // Goes back to previous router location
  const isStudent = () => {
    // Check the guid to work out if the user is student or staff.
        const guid = lst.getUserGuid()
  
        if (guid[0] >= '0' && guid[0] <= '9') {
          return true
        } else {
          return false
        }
    }
  
  return {
   isStudent
  }
}
  